import { useCurrentMedication } from '@/hooks/useCurrentMedication'
import useMedRequestAction from '@/lib/api/med-requests/action'
import { useMedicationRequestStore } from '@/lib/stores/medication-request'

export default function useSaveAdditionalNotes(props?: { doNotResetStore?: boolean }) {
  const medRequest = useCurrentMedication()
  const originalMedRequest = medRequest?.data

  const action = useMedRequestAction({
    enabled: !!originalMedRequest,
    doNotResetStore: props?.doNotResetStore
  })

  const saveAdditionalNotes = () => {
    if (!originalMedRequest) return

    const { notes } = useMedicationRequestStore.getState()

    action.mutate({
      id: originalMedRequest.id,
      action: 'skip',
      additionalNotes: notes
    })
  }

  return { saveAdditionalNotes, isPending: action.isPending }
}
